<template>
  <div class="overflow-hidden border border-stroke bg-white shadow-sm">
    <div class="border-b border-stroke bg-primary px-4 py-3">
      <div class="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h4 class="text-base font-semibold text-white">Métricas de notificações</h4>
          <p class="mt-0.5 text-sm text-secondary">
            Envios por canal — acompanhe o consumo e custo
          </p>
        </div>
        <select
          v-model="selectedPeriod"
          class=" border border-secondary/50 bg-white/10 px-3 py-1.5 text-sm text-white focus:border-secondary focus:outline-none focus:ring-1 focus:ring-secondary">
          <option value="all">Total (todos)</option>
          <option value="current_month">Mês atual</option>
          <option value="last_month">Mês anterior</option>
          <option value="current_year">Ano atual</option>
        </select>
      </div>
    </div>

    <div class="grid grid-cols-2 gap-3 p-4 sm:grid-cols-4">
      <div
        class="flex flex-col items-center -lg border border-stroke bg-gray-50 px-3 py-4 transition hover:border-secondary/50">
        <span class="text-2xl font-bold text-primary">{{ displayMetrics.whatsapp }}</span>
        <span class="mt-1 text-sm font-medium uppercase tracking-wide text-gray-600">WhatsApp</span>
      </div>
      <div
        class="flex flex-col items-center -lg border border-stroke bg-gray-50 px-3 py-4 transition hover:border-secondary/50">
        <span class="text-2xl font-bold text-primary">{{ displayMetrics.sms }}</span>
        <span class="mt-1 text-sm font-medium uppercase tracking-wide text-gray-600">SMS</span>
      </div>
      <div
        class="flex flex-col items-center -lg border border-stroke bg-gray-50 px-3 py-4 transition hover:border-secondary/50">
        <span class="text-2xl font-bold text-primary">{{ displayMetrics.email }}</span>
        <span class="mt-1 text-sm font-medium uppercase tracking-wide text-gray-600">Email</span>
      </div>
      <div
        class="col-span-2 flex flex-col items-center justify-center -lg border-2 border-primary/30 bg-primary/5 px-3 py-4 sm:col-span-1">
        <span class="text-3xl font-bold text-primary">{{ displayMetrics.total }}</span>
        <span class="mt-1 text-sm font-semibold uppercase tracking-wide text-gray-600">Total</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { INotificationMetrics, INotificationMetricsPeriod } from '@/interfaces/entities/user'
import { computed, ref } from 'vue'

const props = defineProps<{
  metrics?: INotificationMetrics | null
}>()

const selectedPeriod = ref<'all' | 'current_month' | 'last_month' | 'current_year'>('all')

const displayMetrics = computed((): INotificationMetricsPeriod => {
  if (!props.metrics) {
    return {
      period: 'all',
      start_date: null,
      end_date: null,
      whatsapp: 0,
      sms: 0,
      email: 0,
      total: 0,
    }
  }
  if (selectedPeriod.value === 'all') {
    return props.metrics.total
  }
  return props.metrics.by_period[selectedPeriod.value] ?? props.metrics.total
})
</script>
